/**
 * The link an editor pastes (a YouTube watch/short link, a Vimeo page) as the
 * URL an `<iframe>` can play. Anything unrecognised passes through unchanged,
 * so an embed URL pasted directly still works.
 */
export function embedUrl(link: string | undefined): string | undefined {
    const value = link?.trim();
    if (!value) return undefined;

    const youtube = value.match(
        /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/,
    );
    if (youtube) return `https://www.youtube-nocookie.com/embed/${youtube[1]}?rel=0`;

    const vimeo = value.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;

    return value;
}
